export interface DealerAppRouteWithVinQuery {
	path: string
	url: (vin?: string) => string
}

export const routeWithVinQuery = (path: string): DealerAppRouteWithVinQuery => ({
	path,
	url: (vin) => (vin ? `${path}?vin=${encodeURIComponent(vin)}` : path),
})
